const TITLE_FONT_SIZE_DIVISOR = 160;
const BODY_FONT_SIZE_DIVISOR = 180;
const DISPLAY_FONT_SIZE_DIVISOR = 90;

interface ScaledFontSizeOptions {
  readonly ceil?: boolean;
}

const getScaledFontSize = (
  contentWidth: number,
  divisor: number,
  { ceil = true }: ScaledFontSizeOptions = {}
): number => {
  const size = contentWidth / divisor;
  return ceil ? Math.ceil(size) : size;
};

export const getTitleFontSize = (
  contentWidth: number,
  options?: ScaledFontSizeOptions
): number => getScaledFontSize(contentWidth, TITLE_FONT_SIZE_DIVISOR, options);

export const getBodyFontSize = (
  contentWidth: number,
  options?: ScaledFontSizeOptions
): number => getScaledFontSize(contentWidth, BODY_FONT_SIZE_DIVISOR, options);

export const getDisplayFontSize = (
  contentWidth: number,
  options?: ScaledFontSizeOptions
): number => getScaledFontSize(contentWidth, DISPLAY_FONT_SIZE_DIVISOR, options);

/**
 * Render titles in a path-like format with underscores instead of spaces.
 * Used exclusively on desktop for window titles, sidebar list, etc.
 */
export const formatDesktopTitle = (title: string): string =>
  title.replaceAll(' ', '_');

/**
 * Appends a zero-padded window number to a desktop title,
 * e.g. `formatDesktopWindowTitle('My Title', 2)` -> `'My_Title_02'`.
 * Used to number the draggable windows on the project detail page on desktop.
 */
export const formatDesktopWindowTitle = (title: string, windowNumber: number): string =>
  `${formatDesktopTitle(title)}_${windowNumber.toString().padStart(2, '0')}`;
